<script setup>
  import Icon from "@/components/icons/Icon.vue";
</script>

<template>
    <span class="jwx-product-locked">
      <Icon class="jwx-product-locked__icon" name="lock-solid" />
    </span>  
</template>